// update flash sale timer
const countdownTag = document.querySelector('.countdown');
const flashSaleInfo = document.querySelector('.flash-sale-info-wrapper');
// time now UTC
let currentTime = Date.now();

// when time is set as UTC use it otherwise use timezone UTC+1
const start = countdownTag.dataset.saleStart;
const end = countdownTag.dataset.saleEnd;

//   if time is set
if (start !== '' && end !== '') {
  // start and end time
  const startTime = new Date(start);
  const endTime = new Date(end);

  // calculate time left
  let secondsLeft = Math.floor((endTime - currentTime) / 1000);

  if (secondsLeft > 0) {
    let hours = Math.floor(secondsLeft / 3600)
      .toString()
      .padStart(2, '0');
    let minutes = Math.floor((secondsLeft % 3600) / 60)
      .toString()
      .padStart(2, '0');
    let seconds = ((secondsLeft % 3600) % 60).toString().padStart(2, '0');

    // set interval to update displayed timer
    countdownTag.innerText = `${hours}h ${minutes}m ${seconds}s`;

    const timer = setInterval(() => {
      // recalculate times
      currentTime = Date.now();
      secondsLeft = Math.floor((endTime - currentTime) / 1000);
      hours = Math.floor(secondsLeft / 3600)
        .toString()
        .padStart(2, '0');
      minutes = Math.floor((secondsLeft % 3600) / 60)
        .toString()
        .padStart(2, '0');
      seconds = ((secondsLeft % 3600) % 60).toString().padStart(2, '0');

      countdownTag.innerText = `${hours}h ${minutes}m ${seconds}s`;
      if (hours === '00' && minutes === '00' && seconds === '00') {
        clearInterval(timer);
      }
    }, 1000);
  }

  // hide elements when they are not within timeframe
  const timeframe = currentTime > startTime && currentTime < endTime;

  if (timeframe) {
    flashSaleInfo.style.display = 'block';
  }
}
